// extracted by mini-css-extract-plugin
export default {"bottom-links__list":"esOOZN","bottom-links__link":"y3DVQ9","bottom-links":"TLPBG4","stores":"Qr1a6B","stores__title":"DY_SHK"};